/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToastProvider, withModalContext } from '@jutro/components';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import _ from 'lodash';
import { PhoneUtil } from '@xengage/gw-portals-viewmodel-js';
import { ServiceManager } from '@jutro/legacy/services';
import { AccountService } from 'gw-capability-gateway-policy';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { MLTagManagerService, withMLModalService } from 'ml-portals-services-react'
import cx from 'classnames';
import moment from 'moment';
import EditContactDetailsPopUp from './EditContactDetailsPopUp';

import accountsMessages from '../Accounts.messages';
import messages from './Contacts.messages';
import styles from './Contacts.module.scss';
import { Button } from '@jutro/legacy/components';

import { TranslatorContext } from '@jutro/legacy/locale';

class ContactsPageWithoutModalContext extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        fromAccountLanding: PropTypes.shape({
            accountDetailsData: PropTypes.shape({
                accountNumber: PropTypes.string,
                accountHolder: PropTypes.shape({
                    displayName: PropTypes.string
                }),
                numberOfContacts: PropTypes.string
            }),
            basePath: PropTypes.string
        }).isRequired,
        location: PropTypes.shape({
            state: PropTypes.shape({
                selectTab: PropTypes.string
            })
        }).isRequired,
        viewModelService: PropTypes.shape({
            create: PropTypes.func.isRequired,
            clone: PropTypes.func.isRequired,
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired
    };

    state = {
        selectedTab: 'accountContactsTab',
        accountData: {}
    };

    componentDidMount() {
        const {
            location: { state },
            fromAccountLanding
        } = this.props;

        if (state && state.selectTab) {
            this.setState({
                selectedTab: state.selectTab
            });
        }
        this.setState({
            accountData: fromAccountLanding.accountDetailsData
        });
    }

    updateAccountContactsHeading = () => {
        const { fromAccountLanding } = this.props;
        const {
            accountDetailsData: { numberOfContacts },
            basePath
        } = fromAccountLanding;
        const translator = this.context;

        const contactsCount = basePath.includes('account') ? `(${numberOfContacts})` : '';

        return translator(
            accountsMessages.accountContactsCount,
            { accountContactsCount: contactsCount }
        );
    };

    showModal = async (accountData) => {
        const translator = this.context;
        MLTagManagerService.sendFormStartEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Edit Profile`);
        const { viewModelService } = this.props
        const result = await this.props.modalContext.showModal(
            <EditContactDetailsPopUp
                title={translator(messages.EditContactDetails) + accountData.accountHolder.displayName}
                actionBtnLabel={messages.Save}
                cancelBtnLabel={messages.Cancel}
                accountData={accountData}
                viewModelService={viewModelService}
                showValidationErrors
            />
        );
        return result;
    }

    handleEditButtonClick = () => {
        const { accountData } = this.state;
        const { authHeader, modalService } = this.props;
        const translator = this.context;
        this.showModal(accountData).then(async (requestObj) => {
            modalService.showProgressDialog(messages.saving)
            try{
                const contactVM = await AccountService.updateAccountHolderContactDetails(requestObj.accountNumber, requestObj.accountHolder, authHeader);
                accountData.accountHolder = contactVM
                this.setState({ accountData });
                MLTagManagerService.sendFormCompleteEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Edit Profile`);
            }catch(error) {
                console.error(error);
                modalService.showErrorModal(messages.error, {...messages.noAccount, args: { accountNumber: accountData.accountNumber }})
            }finally{
                modalService.hideProgressDialog()
            }
        }).catch(_.noop);
    };

    render() {
        const { fromAccountLanding } = this.props;
        const { selectedTab } = this.state;
        const { accountNumber, accountHolder } = fromAccountLanding.accountDetailsData;
        const translator = this.context;

        const formattedDate = moment(accountHolder.dateOfBirth).format('MM/DD/YYYY');
        const phoneUtil = PhoneUtil();
        const localeService = ServiceManager.getService('locale-service');
        const defaultCountryCode = localeService.getDefaultCountryCode();
        let workNumber = '';
        let homeNumber = '';
        let cellNumber = '';
        let faxNumber = '';
        if (accountHolder.workNumber && accountHolder.workNumber.length > 0) {
            workNumber = phoneUtil.prettyPrint(accountHolder.workNumber, defaultCountryCode);
        }
        if (accountHolder.homeNumber && accountHolder.homeNumber.length > 0) {
            homeNumber = phoneUtil.prettyPrint(accountHolder.homeNumber, defaultCountryCode);
        }
        if (accountHolder.cellNumber && accountHolder.cellNumber.length > 0) {
            cellNumber = phoneUtil.prettyPrint(accountHolder.cellNumber, defaultCountryCode);
        }
        if (accountHolder.faxNumber && accountHolder.faxNumber.length > 0) {
            faxNumber = phoneUtil.prettyPrint(accountHolder.faxNumber, defaultCountryCode);
        }

        const displayAddressArray = accountHolder.primaryAddress.displayName.split(', ').reverse();
        const addressDisplayLine1 = accountHolder.primaryAddress.addressLine1;
        const addressDisplayLine2 = accountHolder.primaryAddress.addressLine2 ? accountHolder.primaryAddress.addressLine2 : displayAddressArray[1].concat(', ').concat(displayAddressArray[0]);
        const addressDisplayLine3 = accountHolder.primaryAddress.addressLine2 ? displayAddressArray[1].concat(', ').concat(displayAddressArray[0]) : undefined;

        return (
            <div className={cx(styles.mlAccountHolderSection, "ml-section")}>
                <header>
                    <h2>{_.toString("Account Holder")}</h2>
                </header>
                <hr />
                <div className="row display-flex">
                    <div className="col-md-1">
                        <i className="icon icon-foremost-account-icon icon-lg" /> 
                    </div>
                    <div className="col-md-2">
                        <div>
                            <strong>{accountHolder.displayName}</strong>
                        </div>
                        <br />
                        <div>
                            <strong>{translator(messages.DateOfBirth)}</strong>
                        </div>
                        <div>
                            {formattedDate}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div>
                            <span className={cx(styles.contactIcon, "icon-ml-location")} /> {translator(messages.PrimaryAddress)}
                        </div>
                        <div>
                            <span className={cx(styles.contactIcon)} /> {addressDisplayLine1}
                        </div>
                        <div>
                            <span className={cx(styles.contactIcon)} /> {addressDisplayLine2}
                        </div>
                        {(addressDisplayLine3)? 
                            <div>
                                <span className={cx(styles.contactIcon)} /> {addressDisplayLine3}
                            </div> : <></>
                        }
                    </div>
                    <div className="col-md-4 lines">
                        {(accountHolder.homeNumber)?
                            <div>
                                <span className={cx(styles.contactIcon, "icon-ml-phone")} /> {homeNumber}
                                {(accountHolder.primaryPhoneType === 'home')?
                                    <span>
                                        {translator(messages.Primary)}
                                    </span> : <></>
                                }
                            </div> : <></>
                        }
                        {(accountHolder.workNumber)?
                            <div>
                                <span className={cx(styles.contactIcon, "icon-ml-phone")} /> {workNumber}
                                {(accountHolder.primaryPhoneType === 'work')?
                                    <span>
                                        {translator(messages.Primary)}
                                    </span> : <></>
                                }
                            </div> : <></>
                        }
                        {(accountHolder.cellNumber)?
                            <div>
                                <span className={cx(styles.contactIcon, "icon-mobile-phone")} /> {cellNumber}
                                {(accountHolder.primaryPhoneType === 'mobile')?
                                    <span>
                                        {translator(messages.Primary)}
                                    </span> : <></>
                                }
                            </div> : <></>
                        }
                        {(accountHolder.faxNumber)?
                            <div>
                                <span className={cx(styles.contactIcon, "icon-fax")} />
                                {faxNumber}
                            </div> : <></>
                        }
                        {(accountHolder.emailAddress1)?
                            <div>
                                <span className={cx(styles.contactIcon, "icon-ml-letter")} />
                                {accountHolder.emailAddress1}
                                <span>
                                    {translator(messages.Primary)}
                                </span>
                            </div> : <></>
                        }
                        {(accountHolder.emailAddress2)?
                            <div>
                                <span className={cx(styles.contactIcon, "icon-ml-letter")} />
                                {accountHolder.emailAddress2}
                            </div> : <></>
                        }
                    </div>
                    <div className="col-md-1">
                        <Button type="outlined" onClick={this.handleEditButtonClick}>
                            {translator(messages.Edit)}
                        </Button>
                    </div>
                </div>
                <hr />
            </div>
        );
    }
}
const ContactsPage = withModalContext(ContactsPageWithoutModalContext);
export default withMLModalService(withAuthenticationContext(withViewModelService(ContactsPage)));
